// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"217":"a865b194","559":"22d8981a"}[chunkId] + ".chunk.js";
};